import UserContext from "@context/UserContext";
import { showNotification } from "@easydev/Notification";
import useGetProfile from "@hooks/Security/Account/useGetProfile";
import updateAccountMapper from "@mappers/Security/Account/UpdateAccount.mapper";
import updateAccount from "@services/Core/Account/editAccount";
import ModifyConfirmation from "@shared/Modals/ModifyConfirmation";
import UpdateProfile from "@validators/Security/Account/UpdateProfile.validate";
import AccountIcon from "mdi-react/AccountIcon";
import { ReactElement, useContext, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { TUserContext } from "types/Core/Authentication/userContext";
import ProfileMain from "./components/ProfileMain";
import ProfileSettings from "./components/ProfileSettings";

const Profile = (): ReactElement => {
  const { currentUser, setCurrentUser } = useContext<TUserContext>(UserContext);
  const [modalStatus, setModalStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState<Record<string, any> | undefined>(
    undefined
  );
  const getProfile = useGetProfile(currentUser?.uuid ?? "");
  const profile = getProfile?.data ?? null;

  const handleModalStatus = () => {
    setModalStatus(!modalStatus);
  };

  const handleUpdateProfile = (FormValues: Record<string, any>) => {
    setFormValues(FormValues);
    handleModalStatus();
  };

  const handleConfirmModify = () => {
    setIsLoading(true);
    const userDto = updateAccountMapper(formValues);

    currentUser &&
      updateAccount(currentUser.uuid, userDto)
        .then(async () => {
          showNotification(
            "My Profile | Modify",
            "The user has been edited successfully.",
            "Success"
          );

          currentUser.userName = userDto.username;
          setCurrentUser(currentUser);
        })
        .catch((error: { response: { data: { error: any } } }) => {
          showNotification(
            "My Profile | Modify",
            `An error occurred while modifying the user:  ${error?.response?.data?.error}`,
            "Danger"
          );
        })
        .finally(() => {
          setIsLoading(false);
          handleModalStatus();
        });
  };

  return (
    <Container>
      <ModifyConfirmation
        title={"My Profile | Modify confirmation"}
        body={"Are you sure you want to update the profile?"}
        modalStatus={modalStatus}
        handleModalStatus={handleModalStatus}
        handleConfirmModify={handleConfirmModify}
      />
      <Row>
        <Col md={12}>
          <h3 className="page-title">
            <AccountIcon />
            My Profile
          </h3>
        </Col>
      </Row>
      <Row>
        <Col md={12} lg={12} xl={4}>
          <Row>
            <ProfileMain profile={profile} isLoading={getProfile.loading} />
          </Row>
        </Col>
        <ProfileSettings
          profile={profile}
          isLoading={getProfile.loading}
          isLoadingUpdate={isLoading}
          onSubmit={handleUpdateProfile}
          validateForms={UpdateProfile}
        />
      </Row>
    </Container>
  );
};

export default Profile;
